<template>
    <div class="action-wrapper">
        <slot name="prepend" />

        <slot>
            <div class="searchbar mb-2">
                <v-text-field
                    readonly
                    class="v-input-field--search"
                    outlined
                    clearable
                    dense
                    placeholder="Enter your filters"
                    v-model="filtersResume"
                    @click="flags.show_modal = true"
                    @click:clear.prevent="clear()"
                />
                <v-btn dense class="button" @click="showModal = true">
                    <v-icon small>mdi-magnify</v-icon>
                </v-btn>
            </div>

            <v-dialog width="724" v-model="flags.show_modal" scrollable persistent content-class="bible-form-dialog">
                <v-card flat elevation="0" class="bible-form" style="width: 724px !important; min-width: 600px; max-width: 724px!important;" :loading="flags.fetch_data_records">
                    <v-card-title>
                        <span class="header2">{{ $tc('app.filters') }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6" class="dialog-items">
                                    <span class="label">Carnet estudiante</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.student_license"
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="6" class="dialog-items">
                                    <span class="label">Estado</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.status"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('finished')">
                                <v-col cols="6">
                                    <span class="label">Nombre</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.name"
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Apellido</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.last_name"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <span class="label">Programa</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.program"
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="6" v-if="currentSection.includes('bibles') || currentSection.includes('abandonment')">
                                    <span class="label">Login</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.login"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Asignatura</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.course_name"
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Codigo Asignatura</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.course_abbr"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Aprobada</span>
                                    <v-checkbox
                                        v-model="filters.approved"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"
                                        ></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Reconocida</span>
                                    <v-checkbox
                                        v-model="filters.recognized"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"
                                        ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Suspendida</span>
                                    <v-checkbox
                                        v-model="filters.suspended"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"
                                        ></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">No presentada</span>
                                    <v-checkbox
                                        v-model="filters.not_presented"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"
                                        ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Matricula de Nuevo Ingreso</span>
                                    <v-checkbox
                                        v-model="filters.enrollment_new_access"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Número de veces tomada</span>
                                    <v-text-field
                                        class="input-text input-text--text-field body-text"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-model="filters.take_times"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Primera Matricula</span>
                                    <v-checkbox
                                        v-model="filters.first_enrollment"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Segunda Matricula</span>
                                    <v-checkbox
                                        v-model="filters.second_enrollment"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="currentSection.includes('bibles')">
                                <v-col cols="6">
                                    <span class="label">Tercera Matricula</span>
                                    <v-checkbox
                                        v-model="filters.third_enrollment"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"></v-checkbox>
                                </v-col>
                                <v-col cols="6">
                                    <span class="label">Cuarta Matricula</span>
                                    <v-checkbox
                                        v-model="filters.fourth_enrollment"
                                        hide-details
                                        dense
                                        label="Si"
                                        value="true"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions style="justify-content: center">
                        <v-btn class="v-btn--primary" @click="applyFilters">
                            {{ $tc('app.filter') }}
                        </v-btn>
                        <v-btn class="v-btn--secondary" @click="cancel">
                            {{ $tc('data_gatherings.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </slot>

        <slot name="append" />
    </div>
</template>

<script>
import _ from "lodash";
import {mapActions} from 'pinia';
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import {mapState} from "pinia/dist/pinia";

export default {
    props: {
        columns: {
            type: Array,
            require: true,
            default: () => [],
        },
    },

    data(){
        return {
            currentSection: window.location.pathname,
            flags: {
                fetch_data_records: false,
                show_modal: false,
            },

            filters: {
                name: '',
                last_name: '',
                program: '',
                course_abbr: '',
                student_license: '',
                status: '',
                login: '',
                approved: '',
                recognized: '',
                suspended: '',
                not_presented: '',
                course_name: '',
                take_times: '',
                first_enrollment: '',
                second_enrollment: '',
                third_enrollment: '',
                fourth_enrollment: '',
                enrollment_new_access: ''
            },

            resetFilters: {},
        }
    },

    methods: {
        applyFilters() {
            const filters = Object.assign({}, this.filters);
            const types = ['approved', 'recognized', 'not_presented', 'suspended'];
            const enrollments = ['first_enrollment', 'second_enrollment', 'third_enrollment', 'fourth_enrollment']
            let booleanFields = ['enrollment_new_access'];
            let countTrueTypes = types.filter(key => filters[key] === 'true').length;
            let countTrueEnrollments = enrollments.filter(key => filters[key] === 'true').length;

            let fieldTypes = this.dataGathering.type.options.columns;
            fieldTypes.map((field)=> {
                if(field.cast_as === 'boolean' && field.id !== 'erasmus') {
                    booleanFields = [...booleanFields, field.id];
                }
            });

            const formatStringInput = (field, transformFn) => {
                if (filters[field]) {
                    filters[field] = transformFn(filters[field]);
                }
            }

            formatStringInput('status', (value) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase());
            formatStringInput('login', (value) => value.toLowerCase());
            formatStringInput('program', (value) => value.toUpperCase());

            if (countTrueTypes >= 2){
                types.forEach(key => {
                    if (filters[key] === 'true') {
                        filters[key] = ''
                    } else if (filters[key] === '') {
                        filters[key] = 'false';
                    }
                })
            }

            if (countTrueEnrollments >= 2){
                enrollments.forEach(key => {
                    if (filters[key] === 'true') {
                        filters[key] = ''
                    } else if (filters[key] === '') {
                        filters[key] = 'false';
                    }
                })
            }

            this.setPagination({
                max: 10,
                page: 1,
                pages: null,
                total: null,
                visible_pages: 10,
            });

            this.applyFiltersInStore(filters);

            this.fetch(filters);
        },

        fetch(filters) {
            //flags that handle busy statuses should be in the same component not in the store
            //other alternative: avoid the fetch mutation in this component and emmit a event with the new filters applied
            //in any of this sutuations the shared state module its not compromise with the busy status logic
            //this a presentation (view) layer responsability
            this.flags.fetch_data_records = true;

            this.fetchDataRecords()
                .catch()
                .then(() => {
                    this.$emit('filter', filters);
                    this.flags.fetch_data_records = false;
                    this.flags.show_modal = false;
                });
        },

        cancel(){
            this.filters = Object.assign({}, this.resetFilters);

            this.flags.show_modal = false;
        },

        clear() {
            this.filters = {
                name: '',
                last_name: '',
                program: '',
                course_abbr: '',
                student_license: '',
                status: '',
                login: '',
                approved: '',
                recognized: '',
                suspended: '',
                not_presented: '',
                course_name: '',
                take_times: '',
                first_enrollment: '',
                second_enrollment: '',
                third_enrollment: '',
                fourth_enrollment: '',
                enrollment_new_access: ''
            };

            this.applyFilters();
        },

        ...mapActions(DataRecordsStore, {
            applyFiltersInStore: 'applyFilters',
            fetchDataRecords: 'fetchDataRecords',
            setPagination: 'setPagination'
        }),
    },

    computed: {
        filtersResume: {
            get(){
                return _.map(this.resetFilters, (value, key) => value && value.toString().trim() ? `${key}: ${value}` : null)
                    .filter(value => !!value)
                    .join(', ');
            },
            set() {

            }
        },
        ...mapState(DataRecordsStore, ['dataGathering'])
    },

    watch: {
        'flags.show_modal': {
            handler() {
                this.resetFilters = Object.assign({}, this.filters);
            }
        },
    }
}
</script>

<style scoped lang="scss">
.dialog-items {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px !important;

    .v-input {
        align-items: flex-end !important;
    }
}

.bible-form-dialog .bible-form {
    height: auto;
}

.bible-form-dialog .bible-form >.v-card__actions {
    padding: 8px 16px !important;
}
</style>
